module.exports = {
    path:"/search",
    component:()=>import("../../components/search/searchResult.vue"),
    name:"搜索结果"
}